import React, { useState, Component, BaseSyntheticEvent } from 'react';
import { CQMasterDataStore } from '../../../../store/cq-master-data.store';
import GridTemplateConfigurationController from '../grid-template-config.controller';
import { TemplateSFObjectStore } from '../../../../store/models/template-object.model';
import { CQAppConstant } from '../../../../app-constants';
import { observer } from 'mobx-react';
import {Utility} from '../../../../common/utility';

class GridAdditionalFilter extends Component<any, any>{

    private templateConfigCtrl: GridTemplateConfigurationController;
    private childObjectFields: any;
    constructor(props: any) {
        super(props);
        this.templateConfigCtrl = new GridTemplateConfigurationController();
        this.state = {
            addedCriterias: [],
            isCriteriaValid: false,
            objectFields: {}
        }
    }

    componentDidMount() {
        const viewSourceComponentConfig = CQMasterDataStore.GridObject.gridComponentConfigView;
        if (Object.keys(viewSourceComponentConfig).length > 0) {
            this.setState({
                objectFields: TemplateSFObjectStore.objectFields,
                addedCriterias: viewSourceComponentConfig.hasOwnProperty('addedCriterias') ? viewSourceComponentConfig.addedCriterias : [],
            });
        }
    }

    static getDerivedStateFromProps(prevProps:any,prevState:any) {
        const viewSourceComponentConfig = CQMasterDataStore.GridObject.gridComponentConfigView;
        if (Object.keys(viewSourceComponentConfig).length > 0 && 
            viewSourceComponentConfig['addedCriterias']) {
                return({
                    ...prevState,
                    objectFields: TemplateSFObjectStore.objectFields,
                    addedCriterias: prevState.addedCriterias.length === 0 ? 
                        viewSourceComponentConfig.addedCriterias : prevState.addedCriterias
                });
        }else{
            return(prevState);
        }
    }

    render() {
        const { name } = this.props.fieldInfo;
        const viewSourceComponentConfig = CQMasterDataStore.GridObject.gridComponentConfigView;
        this.childObjectFields = TemplateSFObjectStore.standardObjectFields.fields;
        this.childObjectFields = new Utility().createObjectDeepCopy(this.childObjectFields).sort((a: any, b: any) => { return a.label > b.label ? 1 : (a.label === b.label ? 0 : -1); });
        return (
            <div className="slds-grid slds-grid_vertical">
                {
                    this.state.addedCriterias.length > 0 ? <>
                        <h3 className="slds-text-heading_small slds-m-bottom_small">{name}
                            <div className="slds-float_right">
                                <button 
                                    className="slds-button slds-button_neutral"
                                    onClick={this.hideAdditionalFilter}
                                >{`Hide ${name}`}
                                </button>
                            </div>
                        </h3>
                        {this.state.addedCriterias.length && this.state.addedCriterias.map((criteria: any, criteriaIndex: number) => {
                            return <div className="slds-grid slds-grid_vertical-align-center slds-gutters_x-small full-width">
                                <div className="slds-col slds-m-bottom_small">
                                    <div className="slds-form-element__control">{criteriaIndex + 1}</div>
                                </div>
                                <div className="slds-col slds-size_4-of-12">
                                    <div className="slds-form-element">
                                        <div className="slds-form-element__control">
                                            <div className="slds-select_container">
                                                <select className="slds-select" value={criteria.field} onChange={e => this.onFieldChanged(e, criteriaIndex)}>
                                                    <option value="">Please select</option>
                                                    {this.childObjectFields.length && this.childObjectFields.map((fieldValue: any, index: number) => {
                                                        return (<option key={index} value={fieldValue.name}>{fieldValue.label} - {fieldValue.name}</option>);
                                                    })};
                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="slds-col slds-size_3-of-12">
                                    <div className="slds-form-element">
                                        {/* <label className="slds-form-element__label">Operator</label> */}
                                        <div className="slds-form-element__control">
                                            <div className="slds-select_container">
                                                <select className="slds-select" value={criteria.operator} onChange={e => this.onOperatorChanged(e, criteriaIndex)}>
                                                    <option value="">Select Operator</option>
                                                    {CQAppConstant.GRID_AND_CLAUSE.map((operator: any) => {
                                                        return (<option key={operator.value} value={operator.value}>{operator.label}</option>);
                                                    })}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="slds-col slds-size_3-of-12">
                                    <div className="slds-form-element">
                                        {/* <label className="slds-form-element__label">Value</label> */}
                                        <div className="slds-form-element__control">
                                            <div className="slds-form-element__control">
                                                <input type="text" value={criteria.compareTo} onChange={e => this.onCompateToTextChanged(e, criteriaIndex)}
                                                    placeholder="Placeholder Text" className="slds-input" disabled={criteria.operator === 'Exists' || criteria.operator === 'IsEmpty'} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="slds-col slds-size_2-of-12">
                                    <div className="slds-form-element">
                                        <div className="slds-form-element__control">
                                            <button disabled={!this.state.isCriteriaValid} className="slds-button slds-button_icon slds-button_icon-border-filled" onClick={() => this.addCriteria()}>
                                                <i className="cq-icon-add"></i>
                                            </button>
                                            {criteriaIndex !== 0 &&
                                                <button className="slds-button slds-button_icon slds-button_icon-border-filled" onClick={() => {
                                                    this.deleteCriteria(criteriaIndex);
                                                }}>
                                                    <i className="cq-icon-delete"></i>
                                                </button>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        })}
                    </> : <div className="slds-m-vertical_small">
                            <button className="slds-button slds-button_brand"
                                onClick={this.addAdditionalFilter}>Add {name}</button>
                        </div>
                }
            </div>
        )
    }

    addAdditionalFilter = () => {
        let addedCriterias = [...this.state.addedCriterias];
        addedCriterias = [...addedCriterias, {
            field: '',
            operator: '',
            compareTo: '',
        }];
        this.setState({
            addedCriterias
        });
    }

    hideAdditionalFilter = () => {
        this.setState({
            addedCriterias : []
        });
    }

    /**
     * @private
     * @memberof GridComponentAdditionalFilter
     */
    private onFieldChanged = (e: BaseSyntheticEvent, criteriaIndex: number) => {
        const selectedFieldDetails = this.childObjectFields.filter((field:any)=>(field.name === e.target.value));
        const addedCriterias = this.state.addedCriterias;
        addedCriterias[criteriaIndex].field = e.target.value;
        addedCriterias[criteriaIndex].fieldType = selectedFieldDetails[0].type;
        this.setState({ addedCriterias }, () => this.isCriteriaValid(criteriaIndex));
    }

    /**
     * @private
     * @memberof GridComponentAdditionalFilter
     */
    private addCriteria = () => {
        const critetia = {
            field: '',
            operator: '',
            compareTo: '',
        };
        const addedCriterias = [...this.state.addedCriterias];
        addedCriterias.push(critetia);

        this.setState({
            addedCriterias,
            isCriteriaValid: false
        });
    }

    /**
     *
     *
     * @private
     * @memberof GridComponentAdditionalFilter
     */
    private deleteCriteria = (criteriaIndex: number) => {
        this.setState({ addedCriterias: this.state.addedCriterias.filter((criteria: any, index: number) => index !== criteriaIndex) }, () => {
            this.props.updateViewSourceComponentConfig('addedCriterias', this.state.addedCriterias);
            this.addCriteriaString();
        });
    }

    /**
     *
     *
     * @memberof GridComponentAdditionalFilter
     */
    public addCriteriaString = () => {
        const addedCriterias = [...this.state.addedCriterias];
        let addedCriteriString = '';
        addedCriterias.forEach((criteria: any) => {
            let addedCriteria: string;
            let typeCompare = criteria.fieldType.toLowerCase();
            if(typeCompare === 'number' || typeCompare === 'double' || typeCompare === 'percent' || typeCompare === 'boolean' || typeCompare === 'datetime'|| typeCompare ==='date'){
                addedCriteria = `${criteria.field} ${criteria.operator} ${criteria.compareTo}`;
            }else{
                addedCriteria = `${criteria.field} ${criteria.operator} '${criteria.compareTo}'`;
            }
            addedCriteriString = addedCriteriString ? `${addedCriteriString} AND ${addedCriteria}` : addedCriteria;
        });
        this.setState({
            addedCriteriString
        });
    }

    /**
     *
     *
     * @private
     * @memberof GridComponentAdditionalFilter
     */
    private onOperatorChanged = (e: BaseSyntheticEvent, criteriaIndex: number) => {
        const addedCriterias = this.state.addedCriterias;
        addedCriterias[criteriaIndex].operator = e.target.value;
        addedCriterias[criteriaIndex].compareTo = (addedCriterias[criteriaIndex].operator === 'Exists'
            || addedCriterias[criteriaIndex].operator === 'IsEmpty')
            ? '' : addedCriterias[criteriaIndex].compareTo;
        this.setState({ addedCriterias }, () => this.isCriteriaValid(criteriaIndex));
    }

    /**
     *
     *
     * @private
     * @memberof GridComponentAdditionalFilter
     */
    private onCompateToTextChanged = (e: BaseSyntheticEvent, criteriaIndex: number) => {
        const addedCriterias = this.state.addedCriterias;
        addedCriterias[criteriaIndex].compareTo = e.target.value;
        this.setState({ addedCriterias }, () => this.isCriteriaValid(criteriaIndex));
    }

    /**
     *
     *
     * @private
     * @memberof GridComponentAdditionalFilter
     */
    private isCriteriaValid = (criteriaIndex: number) => {
        const addedCriterias = [...this.state.addedCriterias];
        const addedCriteriaObject = { ...addedCriterias[criteriaIndex] };
        const isInvalid = Object.keys(addedCriteriaObject).filter((criteriaKey) => {
            return addedCriteriaObject[criteriaKey] === '';
        });
        if (isInvalid.length === 0) {
            this.props.updateViewSourceComponentConfig('addedCriterias', addedCriterias);
            this.addCriteriaString();
            this.setState({
                isCriteriaValid: true,
            }, () => {
                this.templateConfigCtrl.updateFieldValue('andClause', this.state.addedCriteriString, this.props.selectedTemplateName);
            })
        }
    }


}

export const GridComponentAdditionalFilter = observer(GridAdditionalFilter);